import type { IContextMutationResult } from '@modules/core/services/query/types';
import { AFFILIATES_APPROVED_PERMISSIONS } from '@modules/affiliates-approved/constants';
import { useRestClient } from '@modules/core/services/api';
import { useContextMutation } from '@modules/core/services/query';
import { useToastStore } from '@modules/toast/store';

import type { IAffiliateGetTrackersSettingsResponse, IAffiliateSaveTrackersSettingsPayload } from '../types';
import {
  AFFILIATE_GET_TRACKERS_SETTINGS_QUERY,
  AFFILIATE_SAVE_TRACKERS_SETTINGS_API_URL,
  AFFILIATE_SAVE_TRACKERS_SETTINGS_MUTATION,
} from '../constants';

export default function useAffiliateSaveTrackersSettingsMutation(): IContextMutationResult<void, Error, IAffiliateSaveTrackersSettingsPayload> {
  const { fetchPut } = useRestClient();
  const { displayPresetToast } = useToastStore();

  return useContextMutation<void, Error, IAffiliateSaveTrackersSettingsPayload>({
    mutationKey: [AFFILIATE_SAVE_TRACKERS_SETTINGS_MUTATION],
    mutationFn: ({ id, ...payload }) => fetchPut<void>(
      AFFILIATE_SAVE_TRACKERS_SETTINGS_API_URL,
      payload,
      {
        permission: AFFILIATES_APPROVED_PERMISSIONS.AFFILIATES_SHOW,
        urlParams: {
          id,
        },
      },
    ),
    onSuccess({ queryClient, variables }) {
      queryClient.setQueriesData<IAffiliateGetTrackersSettingsResponse>(
        { queryKey: [AFFILIATE_GET_TRACKERS_SETTINGS_QUERY, variables.id] },
        (queryData) => {
          if (!queryData) {
            return queryData;
          }

          return {
            ...queryData,
            affiliate: {
              ...queryData.affiliate,
              max_count_trackers: variables.affiliate.max_count_trackers,
            },
          };
        },
      );

      displayPresetToast('edited');
    },
  });
}
